const transformChild = (item, action) => {
  const index = action();

  return {
    ...item,
    index,
    isActive: index === 0,
    isCompleted: false,
  };
};

export const isJSON = (json) => {
  try {
    JSON.parse(json);
    return true;
  } catch (error) {
    return false;
  }
};

export const debounce = (func, wait) => {
  let timeout;

  return (...args) => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
};

export const deepMerge = (obj1, obj2) => {
  const merged = {
    ...obj1,
    ...obj2,
  };

  Object.keys(merged).forEach((key) => {
    if (merged[key] instanceof Object && !(merged[key] instanceof Array)) {
      merged[key] = deepMerge(obj1[key], obj2[key]);
    }
  });

  return merged;
};

export const deepCopy = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

export const sleep = (ms = 400) => new Promise((r) => setTimeout(r, ms));

export const normalizeSteps = (steps = []) => {
  let id = 0;

  const incrementId = () => id++;

  return steps.map((s, i) => {
    const children = s.children.map((e) => transformChild(e, incrementId));

    return {
      ...s,
      children,
      isCompleted: false,
      isActive: i === 0,
      steps: children.length ? children.map((e) => e.index) : [id++],
    };
  });
};

export const convertTime24To12 = (time) => {
  let _time = time
    .toString()
    .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (_time.length > 1) {
    _time = _time.slice(1);
    _time[5] = Number(_time[0]) < 12 ? 'am' : 'pm';
    _time[0] = Number(_time[0]) % 12 || 12;
  }
  return _time.join('');
};

export const removeSpacing = (str) => {
  let link = str;
  link = link ? link.replaceAll('\n\n\n\n', '\n\n') : '';
  if (link.includes('\n\n\n\n')) {
    link = removeSpacing(link);
  }
  return link;
};

export const convertEmailTemplate = (value) => {
  if (!value) return '';
  let links = value;
  links = links.replaceAll('href="', 'href="http://');
  links = links.replaceAll('href="http://http://', 'href="http://');
  links = links.replaceAll('href="http://https://', 'href="https://');
  while (links.includes('\n\n')) {
    links = links.replaceAll('\n\n', '\n');
  }
  links = links.replaceAll('\n', '<p><br></p>');

  // Find all HTML tags with the index of them in the email template
  // If the tag is <br> or <li> do not add any style
  // For <ul> add 'style="margin:0px;padding-left:1.5em"' to the <ul>
  // For any other tag add 'style="margin:0px;padding:0px"'
  const tagStack = [];
  for (let i = 0; i < links.length; i++) {
    if (links[i] === '<' && links[i + 1] !== '/') {
      const spaceIndex = links.substring(i).indexOf(' ');
      const endOfTagIndex = links.substring(i).indexOf('>');
      let tagName = links.substring(i).substring(0, spaceIndex);
      const fullTag = links.substring(i).substring(0, endOfTagIndex);
      if (
        spaceIndex === -1 ||
        (endOfTagIndex !== -1 && endOfTagIndex < spaceIndex)
      )
        tagName = links.substring(i).substring(0, endOfTagIndex);
      if (
        tagName === '' ||
        (tagName.length > 2 && ['br', 'li'].includes(tagName.substring(1, 3)))
      )
        // eslint-disable-next-line no-continue
        continue;
      if (
        tagName.substring(1, 3) === 'ul' &&
        !fullTag.includes('style="margin:0px;padding-left:1.5em"')
      ) {
        tagStack.push([
          i + tagName.length,
          'style="margin:0px;padding-left:1.5em"',
        ]);
      } else if (!fullTag.includes('style="margin:0px;padding:0px"')) {
        tagStack.push([i + tagName.length, 'style="margin:0px;padding:0px"']);
      }
    }
  }
  // Pop through tagStack and add the given style to the tag
  for (let i = tagStack.length - 1; i >= 0; i--) {
    const index = tagStack[i][0];
    const style = tagStack[i][1];
    links = `${links.slice(0, index)} ${style}${links.slice(index)}`;
  }
  return links;
};

export const convertEmailTemplateForLinkedIn = (links) => {
  const div = document.createElement('div');
  div.innerHTML = links;
  const c = div.childNodes;
  let i = 0;
  for (i = 0; i < c.length; i += 1) {
    if (c[i].nodeName === 'A' || c[i].nodeName === 'a') {
      const l = c[i].getAttribute('href');
      c[i].innerHTML = `${c[i].innerText} (${l})`;
    }
  }
  const result = div.innerText;
  div.remove();
  return result;
};

export const removeEmptyInArray = (arr) => {
  if (arr.length > 1) {
    return arr.filter((item) => item !== '');
  }

  return arr;
};

export const emailRules = [
  (value) => !!value || 'Required.',
  (value) => {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || 'Invalid e-mail.';
  },
];

export const sortData = (data = []) => {
  const arr1 = data.filter(
    (item) => item.name === 'Unknown' || item.name === 'Other'
  );
  const arr2 = data.filter(
    (item) => item.name !== 'Unknown' && item.name !== 'Other'
  );
  const sortArr1 = arr1.sort((a, b) => {
    if (a.number > b.number) {
      return -1;
    }
    if (a.number < b.number) {
      return 1;
    }
    return 0;
  });
  const sortArr2 = arr2.sort((a, b) => {
    if (a.number > b.number) {
      return -1;
    }
    if (a.number < b.number) {
      return 1;
    }
    return 0;
  });
  return [...sortArr2, ...sortArr1];
};

export const sortChartData = (data = []) => {
  const arr1 = data.filter(
    (item) => item.key === 'Unknown' || item.key === 'Other'
  );
  const arr2 = data.filter(
    (item) => item.key !== 'Unknown' && item.key !== 'Other'
  );
  const sortArr1 = arr1.sort((a, b) => {
    if (a.value > b.value) {
      return -1;
    }
    if (a.value < b.value) {
      return 1;
    }
    return 0;
  });
  const sortArr2 = arr2.sort((a, b) => {
    if (a.value > b.value) {
      return -1;
    }
    if (a.value < b.value) {
      return 1;
    }
    return 0;
  });
  return [...sortArr2, ...sortArr1];
};

export const isURL = (str) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // Protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z\\d]{2,}|' + // Domain name (allows digits in TLD)
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // IPv4
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // Port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // Query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  );
  return !!pattern.test(str) || 'Not a valid URL.';
};

export const compareTwoArray = (str1, str2) => {
  return JSON.stringify(str1) === JSON.stringify(str2);
};

// Converts Old Templates (with \n linebreaks) to basic HTML
export const convertEmailTemplateToHTML = (emailTemplate) => {
  const arr = emailTemplate?.trim().split('\n') ?? [];
  let HTMLTemplate = '';
  arr.forEach((element) => {
    if (element === '') {
      return;
    }
    if (!element.startsWith('<p')) {
      HTMLTemplate += `<p>${element.trim()}`;
    } else {
      HTMLTemplate += `${element.trim()}`;
    }
    if (!element.trim().endsWith('</p>')) {
      HTMLTemplate += '</p>';
    }
    HTMLTemplate += `<p><br></p>`;
  });
  // Get rid of extra line breaks at the end of the template
  while (HTMLTemplate.endsWith(`<p><br></p>`)) {
    HTMLTemplate = HTMLTemplate.substring(
      0,
      HTMLTemplate.length - `<p><br></p>`.length
    );
  }
  return HTMLTemplate;
};

export const makeid = (length) => {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const checkIsEmail = (email) => {
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !!pattern.test(email) || 'Invalid e-mail.';
};
export const removeTagHTML = (html) => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};
// function get 200 words of content
export const getStringByLimitWords = (content, limit) => {
  const contentArr = content.split(' ');
  const max = Math.min(contentArr.length, limit);
  return contentArr.slice(0, max).join(' ');
};

// function get number of words
export const getNumberOfWords = (content) => {
  const contentArr = content.split(' ');
  return contentArr.length;
};
export const validatePhoneNumber = (phoneNumber) => {
  // Define a regex pattern for US phone numbers
  const phonePattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  // Test the phone number against the pattern
  return phonePattern.test(phoneNumber);
};
export const isHttpUrl = (url) => {
  return url.startsWith('http://') || url.startsWith('https://');
};
